import { cropImage } from './image.js';
export function cropOwlWindow(source, layout) { return cropImage(source, layout.window.rect); }
export function cropOwlItemName(source, layout) { return cropImage(source, layout.itemName); }
export function cropOwlTotalCount(source, layout) { return cropImage(source, layout.totalCount); }
export function cropOwlPageIndicator(source, layout) { return cropImage(source, layout.pageIndicator); }
//# sourceMappingURL=crops.js.map